import { useTheme } from "../../../theme/ThemeProvider";
import { ITheme } from "../../../theme/ITheme";
import { IDrawerStyles } from "../../styles";

export const useDrawerStyles = (theme?: ITheme): IDrawerStyles => {
    if (theme === undefined) {
        theme = useTheme();
    }

    return {
        body: {

        },
        container: {

        },
        footer: {

        },
        footerButton: {
            color: theme.palette.white,
            backgroundColor: theme.palette.grey
        },
        footerButtonPrimary: {
            color: theme.palette.white,
            backgroundColor: theme.palette.accent.dark,
            border: `1px solid ${theme.palette.accent.dark}`,
            borderRadius: theme.shape.borderRadiusSm,
            boxShadow: "none",
        },
        footerButtonIcon: {
            fontSize: "1.25em",
        },
        header: {

        },
        headerTitle: {
            color: theme.palette.text.main,
            fontWeight: theme.font.weights.bold,
            alignContent: "center",
        },
        headerButton: {
            fontSize: "1.25em",
        },
        headerButtonIcon: {
            color: theme.palette.text.dark,
        },
    }
}